import cx from 'classnames';
import { useRef } from 'react';
import { Container } from 'ui/components/4-habitats/Container';
import { SearchFilter, SearchFilterProps } from '../SearchFilter';
import { Pagination, PaginationProps } from 'ui/components/2-molecules/Navigation/Pagination';
import styles from './SearchResultView.module.scss';
import { HeroCanvasPageProps, HeroCanvasPage } from '../Hero';
import { SearchResultListProps, SearchResultList } from '../Lists';

export interface SearchResultViewProps {
	className?: string;
	hero: HeroCanvasPageProps;
	filterProps: SearchFilterProps;
	resultListProps: SearchResultListProps;
	pagination: PaginationProps;
	fallbackText?: string;
}

export const SearchResultView: React.FC<SearchResultViewProps> = ({
	className,
	hero,
	filterProps,
	resultListProps,
	pagination,
	fallbackText,
}) => {
	const searchResultListRef = useRef<HTMLDivElement>(null);
	const filter = filterProps && (
		<SearchFilter
			{...filterProps}
			onSubmit={() =>
				searchResultListRef?.current && searchResultListRef.current.scrollIntoView({ behavior: 'smooth' })
			}
		/>
	);
	const hasResults = resultListProps?.results?.length > 0;

	return (
		<div className={cx(styles.SearchResultView, className)}>
			{hero ? <HeroCanvasPage {...hero} searchFilter={filter} /> : filter}
			<Container>
				<SearchResultList {...resultListProps} resultListRef={searchResultListRef}>
					{!hasResults && fallbackText && <p>{fallbackText}</p>}
				</SearchResultList>
			</Container>
			{pagination?.pageCount > 1 && (
				<Container>
					<Pagination {...pagination} />
				</Container>
			)}
		</div>
	);
};
